module.exports = __webpack_public_path__ + "static/media/Bottom-Shape.41b06e4f.png";